export const mapAccountToAccountSelectionDefault = (row) => {
    const account = row.columns;
    return {
        id: row.id,
        account,
        options: {},
    };
};
